export const boardPackageTour = {
  key: "boardPackage",
  version: 1,
  getSteps: (t) => [
    {
      target: '[data-tour="board-package-current"]',
      content: t("Tour_BoardPackage_Current"),
      placement: "right",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-package-calculator"]',
      content: t("Tour_BoardPackage_Calculator"),
      placement: "left",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-package-payment"]',
      content: t("Tour_BoardPackage_Payment"),
      placement: "top",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-package-submit"]',
      content: t("Tour_BoardPackage_Submit"),
      placement: "top",
    },
  ],
};
